import {Text} from '#component/base';

import * as css from './DiscountErrorMessageBox.css';

export const DiscountErrorMessageBox = ({discountCode}: {discountCode: string}) => {
  return (
    <div className={css.discountErrorMessageBox}>
      <Text className={css.discountErrorMessageBoxText} as="p" variant="body" color="eggplant">
        {`'${discountCode.toUpperCase()}' could not be applied to this plan subject to the terms & conditions of the
        promotion`}
      </Text>
    </div>
  );
};
